import { Card } from "@repo/ui";
import withAnimation from "../../hoc/withCardAnimation/withCardAnimation";

const AnimatedCard = withAnimation(Card);

export default AnimatedCard;
